import { Observable } from 'rxjs';

import { BaseDataSource } from './base.datasource';
import { DataSourceParams, IBaseTableResult } from 'app/store/models/table.model';

export class StaticDataSource<T> extends BaseDataSource<T> {
  private items: T[] = [];

  constructor(items: T[]) {
    super();

    this.items = items;
  }

  setItems(items: T[]) {
    this.items = items;
  }

  loadData(data: DataSourceParams): Observable<IBaseTableResult<T>> {
    const targetItems = this.items && this.items.length ? this.items.slice(
      (data.page - 1) * data.pageSize,
      (data.page - 1) * data.pageSize + data.pageSize,
    ) : [];
    return new Observable(subscribe => {
      subscribe.next({
        items: targetItems,
        count: targetItems.length,
        has_more_data: targetItems.length < this.items.length,
        current_page: data.page,
        current_page_size: data.pageSize,
        total_count: this.items.length,
        total_page_count: Math.round(this.items.length / data.pageSize) || 1,
        extra_data: null,
      });
      subscribe.complete();
    });
  }
}
